<template>
  <div class="subscriptionBenefits">
    <div class="switchLient fixed0" id="fixed0">
      <div class="carmodel" @click="show = true">
        <div class="carmodelname">{{ modelName }}</div>
        <div class="selectIcon">
          <img :src="show ? selectopen : selectclosed" alt="" />
        </div>
      </div>
    </div>

    <div class="topHeight"></div>

    <div class="contentBg swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in bannerImgs" :key="index">
          <img :src="item" alt="" />
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination" v-show="bannerImgs.length > 1"></div>
    </div>

    <mt-popup v-model="show" position="bottom">
      <div class="popup-tool">
        <div class="cancel" @click="cancel">取消</div>
        <div class="really" @click="rellay">确定</div>
      </div>
      <mt-picker
        :slots="slots"
        @change="onValuesChange"
        :visibleItemCount="3"
        :itemHeight="46"
      ></mt-picker>
    </mt-popup>
  </div>
</template>
<script>
import Swiper from "swiper";
import dataServer from "@/api/data";

export default {
  data() {
    return {
      selectclosed: require("./../assets/img/selectclosed.png"),
      selectopen: require("./../assets/img/selectopen.png"),
      darkMode: false,
      swiper: null,
      show: false,
      slots: [
        {
          flex: 1,
          values: [],
          textAlign: "center",
        },
      ],
      carModelArr: [
        {
          name: "阿尔法S 森林版/阿尔法T 森林版",
          imgs: [],
        },
        {
          name: "阿尔法S 先行版",
          imgs: [],
        },
        {
          name: "阿尔法S/阿尔法T",
          imgs: [],
        },
      ],
      modelName: "",
      bannerImgs: [],
      current: "",
      selectCurrent: "",
      pageInfo: [],
    };
  },
  mounted() {
    this.isDarkMode();

    window.onscroll = function () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop < 0) {
        document.querySelector("#fixed0").style.position = "absolute";
      } else {
        document.querySelector("#fixed0").style.position = "fixed";
      }
    };
    this.getPageInfo();
  },
  methods: {
    getPageInfo() {
      dataServer.findVehicleOwnerRights().then((result) => {
        if (result.status === "SUCCEED") {
          this.pageInfo = result.data;

          // 绑定页面元素
          this.modelName = this.pageInfo[0].vehicleModelName;
          this.bannerImgs = this.pageInfo[0].imgs;

          //绑定变量
          this.slots[0].values = [];
          this.carModelArr = [];
          this.pageInfo.forEach((element) => {
            this.slots[0].values.push(element.vehicleModelName);
            this.carModelArr.push({
              name: element.vehicleModelName,
              imgs: element.imgs,
            });
          });

          this.$nextTick(() => {
            this.myswiper();
          });
        }
      });
    },
    onValuesChange(picker, values) {
      this.current = values[0];
    },
    rellay() {
      this.show = false;
      this.selectCurrent = this.current;
      let choiceModelArr = this.carModelArr.filter((v) => v.name == this.selectCurrent);
      this.bannerImgs = choiceModelArr[0].imgs;
      this.modelName = this.selectCurrent;
      this.show = false;
      this.$nextTick(() => {
        this.swiper.realIndex = 0;
        this.swiper.activeIndex = 0;
        this.swiper.update();
      });
    },
    cancel() {
      this.show = false;
    },
    myswiper() {
      this.swiper = new Swiper(".swiper-container", {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        pagination: {
          el: ".swiper-pagination",
        },
      });
      // this.swiper.slideTo(0, 0)
      // this.$forceUpdate();
    },
    changeContent(value) {
      this.swiper.realIndex = 0;
      this.swiper.activeIndex = 0;
    },
    isDarkMode() {
      let query = window.location.search.substring(1);
      let vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == "colorMode") {
          this.darkMode = true;
          return;
        }
      }
      this.darkMode = false;
      return;
    },
  },
};
</script>
<style lang="scss">
@import url("./../../node_modules/swiper/css/swiper.css");
.subscriptionBenefits {
  background-color: #171717 !important;
  img {
    width: 100%;
  }
  min-height: 100%;
  overflow: hidden;
}
.swiper-wrapper {
  height: auto;
}

.contentBg .swiper-wrapper {
  height: 100%;
}
.contentBg .swiper-slide {
  height: 0;
}
.contentBg .swiper-slide-active {
  height: 100%;
}

.contentBg {
  height: calc(100% - 0.4rem);
  overflow: hidden;
}

.switchLient {
  width: 100%;
  height: 0.4rem;
  background: #171717 !important;
}

.fixed0 {
  position: fixed;
  top: 0;
  z-index: 9999;
}

.carmodel {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  text-align: left;
  font-size: 0.16rem;
  line-height: 0.4rem;
  color: #d8d8d8;
  padding-left: 0.22rem;
  border-bottom: 1px solid #545654;
}

.carmodelname {
  float: left;
  width: 80%;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}

.selectIcon {
  float: right;
  margin-right: 0.2rem;
  width: 0.24rem;
  height: 0.24rem;
}

.choice {
  position: absolute;
  width: 30px;
  height: 3px;
  bottom: 0px;
  left: 50%;
  margin-left: -15px;
  background: #fff;
  border-radius: 20%;
}
.topHeight {
  width: 100%;
  height: 0.4rem;
}
.swiper-container {
  position: relative;
}
.swiper-pagination {
  position: fixed;
  bottom: 0.2rem !important;
}
.swiper-pagination-bullet {
  width: 4px;
  height: 4px;
  background: #faffff;
  opacity: 0.4;
  margin: 0 5px !important;
}

.swiper-pagination-bullet-active {
  width: 14px;
  height: 14px;
  background: url("../assets/img/paginationActive.png");
  background-size: 100% 100%;
  border-radius: 0;
  margin: -4px 4px !important;
  opacity: 2;
}

.mint-popup {
  width: 100%;
}
.popup-tool {
  overflow: hidden;
}
.select-fixed {
  clear: both;
}
.really,
.cancel {
  color: #4798cb;
  float: right;
  width: 32px;
  margin-top: 5px;
  font-size: 16px;
  line-height: 32px;
  margin-right: 20px;
}
.cancel {
  float: left;
  margin-left: 20px;
}
.select-tool {
  height: 50px;
  width: 100%;
  position: absolute;
  top: 0%;
  left: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  .detail-item {
    // padding-bottom: 5px;
  }
  img {
    width: 20px;
    transform: translateY(-2px);
  }
}
.select-params {
  float: left;
  line-height: 50px;
  font-size: 16px;
  font-weight: bold;
  text-indent: 20px;
}
.place {
  height: 104px;
}
.select-switch {
  float: right;
  margin-right: 10px;
  margin-top: 10px;
  .mint-switch-core {
    width: 40px;
    height: 24px;
    &::before {
      width: 40px;
      height: 24px;
    }
    &::after {
      margin-top: -1px;
      margin-left: -1px;
      width: 24px;
      height: 24px;
    }
  }
}
.sub {
  .detail-item {
    padding-bottom: 10px;
  }
}
.mint-switch-input:checked + .mint-switch-core {
  border-color: #4798cb;
  background-color: #4798cb;
}

.table-block td,
.table-block th {
  border: 1px solid #272b2e !important;
}

.select-fixed th {
  background: #1b2328 !important;
}
.select-params {
  color: #fff !important;
}
.mark {
  background: #171717 !important;
}
.select-tool {
  background-color: #171717 !important;
}
.detail-item {
  background-color: #171717 !important;
}
.table-block tbody tr:nth-child(2n),
.table-block thead {
  background-color: #171717 !important;
}
.table-block table,
.table-block td {
  background-color: #171717 !important;
}
.settingDetail .dot-black {
  background-color: #7e7e7e !important;
}
.settingDetail .dot-blank {
  border: 1px solid #7e7e7e !important;
}
.settingDetail {
  background-color: #171717 !important;
}
.mint-popup {
  background-color: #171717 !important;
}
.picker-item.picker-selected {
  color: #fff !important;
}
.picker-item {
  color: #7e7e7e !important;
}

.detail-item {
  margin-bottom: 0 !important;
}
</style>
<style>
.mint-actionsheet-listitem,
.mint-actionsheet-button {
  color: #c8c8c8 !important;
  background-color: #1c1c1c !important;
}
.mint-actionsheet-listitem {
  border-bottom: solid 1px #333 !important;
}
.picker-center-highlight:before,
.picker-center-highlight:after {
  background: none !important;
}
</style>
